import { DEFAULT_ISLAND_KEY } from 'alakai-aloha-shared';

const WEATHER_DATA_ISLAND_BY_SITE_ISLAND = {
  kauai: 'kauai',
  oahu: 'oahu',
  maui: 'maui',
  big_island: 'big-island',
};

export function getWeatherDataIslandKey(siteIsland = DEFAULT_ISLAND_KEY) {
  return WEATHER_DATA_ISLAND_BY_SITE_ISLAND[siteIsland] || WEATHER_DATA_ISLAND_BY_SITE_ISLAND[DEFAULT_ISLAND_KEY];
}

export function getIslandWeatherLocations(locations, siteIsland = DEFAULT_ISLAND_KEY) {
  const weatherIslandKey = getWeatherDataIslandKey(siteIsland);
  if (!Array.isArray(locations)) {
    return [];
  }
  return locations.filter((location) => location?.island === weatherIslandKey);
}

export function getDefaultWeatherLocationId(locations, siteIsland = DEFAULT_ISLAND_KEY) {
  return getIslandWeatherLocations(locations, siteIsland)[0]?.id || locations?.[0]?.id || '';
}
